import { getAsset, RootStateType as AssetsRootStateType } from 'store/assets';
import { ImageType } from 'store/programItems';
import { ExerciseType, RootStateType } from './exercises';

export const getExercises = (rootState: RootStateType): ExerciseType[] => {
	return rootState.exercises.index;
};

export const getSelectedExercise = (rootState: RootStateType, exerciseId: string | null): ExerciseType | undefined => {
	if (!exerciseId || !rootState.exercises || !rootState.exercises.byExternalId) {
		return undefined;
	}
	return rootState.exercises.byExternalId[exerciseId];
};

export const getSelectedExercisePreviewImage = (
	rootState: RootStateType,
	exerciseId: string | null
): ImageType | undefined => {
	const selectedExercise = getSelectedExercise(rootState, exerciseId);

	if (selectedExercise) {
		return selectedExercise.overrideImage as any;
	}

	return undefined;
};

export const getPreselectedExercisePreviewImage = (
	rootState: RootStateType,
	exerciseId: string | null,
	workoutId: string
): ImageType | undefined => {
	const preselectedExerciseId = rootState.exercises.preselectedExerciseIdsPerWorkout[workoutId];
	const selectedExercise = getSelectedExercise(rootState, preselectedExerciseId || exerciseId);

	if (selectedExercise) {
		return selectedExercise.overrideImage as any;
	}

	return undefined;
};

export const getExerciseImage = (
	state: RootStateType & AssetsRootStateType,
	workoutId: string | number,
	exerciseId?: string
) => {
	const preselectedExerciseId = state.exercises.preselectedExerciseIdsPerWorkout[workoutId];
	const selectedExercise = getSelectedExercise(state, preselectedExerciseId || exerciseId || null);

	if (selectedExercise && selectedExercise.overrideImage) {
		return selectedExercise.overrideImage;
	}

	return getAsset(state, 'workout/fallback');
};
